import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { BANNER_BG, logoSource } from "@/lib/bannerLayout";
import { BannerLogo } from "@/components/banner/BannerItems";
import { Search, ImageOff } from "lucide-react";

const TIER = { gold: "bg-amber-400 text-amber-950", silber: "bg-slate-300 text-slate-800", bronze: "bg-orange-300 text-orange-950" };

function Thumb({ p }) {
  return (
    <span className="h-10 w-16 shrink-0 rounded grid place-items-center p-1" style={{ backgroundColor: BANNER_BG }}>
      {logoSource(p) ? <BannerLogo partner={p} /> : <ImageOff size={14} className="text-white/50" />}
    </span>
  );
}

export function SlotPicker({ open, onClose, num, partners, current, usedOn, onPick }) {
  const [q, setQ] = useState("");
  const list = partners.filter((p) => !p.archived && p.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) { setQ(""); onClose(); } }}>
      <DialogContent className="max-w-lg" data-testid="banner-slot-picker">
        <DialogHeader><DialogTitle className="text-base">Logofeld {num} belegen</DialogTitle></DialogHeader>
        <div className="relative">
          <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Partner oder Sponsor suchen" className="pl-8" data-testid="banner-picker-search" />
        </div>
        <div className="max-h-[50vh] overflow-y-auto -mx-1 space-y-1">
          {list.map((p) => (
            <button key={p.id} type="button" onClick={() => onPick(p.id)} data-testid={`banner-picker-option-${p.id}`}
              className={`w-full flex items-center gap-3 rounded-lg px-2 py-1.5 text-left transition-colors hover:bg-slate-100 ${p.id === current ? "bg-slate-100 ring-1 ring-slate-300" : ""}`}>
              <Thumb p={p} />
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-1.5 text-sm font-medium text-slate-900">{p.name}
                  {p.tier && <span className={`rounded px-1 text-[9px] font-bold uppercase ${TIER[p.tier]}`}>{p.tier}</span>}</span>
                <span className="block text-xs text-slate-500">
                  {[p.partner_kind === "partner" ? "Partner" : "Sponsor", !p.logo && !p.print && "noch kein Banner-Logo", usedOn[p.id]?.length && `schon auf Feld ${usedOn[p.id].join(", ")}`, p.booked && !usedOn[p.id]?.length && "gebucht, noch ohne Feld"].filter(Boolean).join(" · ")}
                </span>
              </span>
            </button>
          ))}
          {list.length === 0 && <p className="px-2 py-6 text-center text-sm text-slate-400">Keine Treffer</p>}
        </div>
        {current && <Button variant="outline" onClick={() => onPick(null)} className="text-red-600 border-red-200 hover:bg-red-50" data-testid="banner-picker-clear">Feld leeren</Button>}
      </DialogContent>
    </Dialog>
  );
}
